import t from"react";var e=t.createContext(null);export{e as default};
//# sourceMappingURL=TransitionGroupContext.js.map
